export const GET_CONSENTS = /* GraphQL */ `
  query GetConsents {
    me {
      consents {
        call
        email
        health
        healthProcessing
        knowledge
        text
      }
    }
  }
`;
